import { Button, Drawer, Input, Space, Table, Form } from "antd";
import { useContext, useEffect, useState } from "react";

import { ExportToExcel } from "../../../utils/exportExcel";

import { useQuery } from "@tanstack/react-query";
import Something from "../../../components/shared/Something";
import Moment from "react-moment";
import { ColumnsType } from "antd/es/table";
import { AuthContext } from "../../../contexts/AuthContext";
import { handleFetchEntries } from "../../../api/entries";
import moment from "moment";
import { Download, Funnel, X } from "lucide-react";
const { Search } = Input;

export default function AllEntries({
  title = "All Entries",
  status,
  gender = "",
  isVisible,
  setVisible,
  regionId = "",
  districtId = "",
  wardId = "",
  branchId = "",
  modelId = "",
  makeId = "",
  startDate = "",
  endDate = "",
}: any) {
  const { user } = useContext(AuthContext);
  const [search, setSearch] = useState("");
  const [form] = Form.useForm();
  const access = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  const deleteAccess = [9];
  const params = `name=${search}&branch=${branchId}&region=${regionId}&district=${districtId}&ward=${wardId}&model=${modelId}&make=${makeId}&gender=${gender}&startDate=${startDate}&endDate=${endDate}`;

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 24,
    total: 0,
  });

  const {
    data: entries,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["entries", pagination.page, pagination.limit, params],
    queryFn: () =>
      handleFetchEntries({
        page: pagination.page,
        limit: pagination.limit,
        status: status || "",
        params,
      }),
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }
  const getColumns = (user: any, access: any) => {
    const columns: ColumnsType<DataType> = [
      {
        title: "S/N",
        width: 40,
        render: (record: any, text: any, index: any) => (
          <span className="text-gray-700 ml-2">
            {pagination?.page * pagination?.limit -
              pagination?.limit +
              index +
              1}
          </span>
        ),
        fixed: "left",
      },
      {
        title: "DATE",
        width: 100,
        render: (record: any) => (
          <span className="text-gray-700">
            <Moment format="DD/MM/YYYY">{record?.createdAt}</Moment>
          </span>
        ),
      },
      {
        title: "CUSTOMER",
        width: 280,
        render: (record: any) => {
          return (
            <div className="text-black capitalize truncate">
              {record?.name || "-"}
            </div>
          );
        },
      },
      {
        title: "LOCATION",
        width: 290,
        render: (record: any) => {
          return (
            <div className="text-black capitalize">
              {record?.ward}, {record?.district}, {record?.region}
            </div>
          );
        },
      },
      {
        title: "GENDER",
        width: 100,
        render: (record: any) => {
          return (
            <div className="text-black capitalize">{record?.gender || "-"}</div>
          );
        },
      },
      {
        title: "BRANCH",
        width: 100,
        render: (record: any) => {
          return <div className="text-black">{record?.branch}</div>;
        },
      },
      {
        title: "MOBILE",
        width: 180,
        render: (record: any) => {
          return <div className="text-black">{record?.mobile || "-"}</div>;
        },
      },
      {
        title: "VEHICLE",
        width: 120,
        render: (record: any) => {
          return (
            <div className="text-gray-700">
              <div className="">{record?.registration}</div>
            </div>
          );
        },
      },
      {
        title: "MAKE",
        width: 300,
        render: (record: any) => (
          <span className="text-gray-700">{record?.make}</span>
        ),
      },
      {
        title: "MODEL",
        width: 300,
        render: (record: any) => (
          <div className="text-gray-700 truncate">{record?.model}</div>
        ),
      },
      {
        title: "YEAR",
        width: 100,
        render: (record: any) => (
          <span className="text-gray-700">{record?.year}</span>
        ),
      },
      {
        title: "MILEAGE",
        width: 100,
        render: (record: any) => (
          <span className="text-gray-700">{record?.mileage}</span>
        ),
      },
      {
        title: "CREATED AT",
        width: 140,
        fixed: "right",
        render: (record: any) => (
          <span className="text-gray-700">
            <Moment fromNow>{record?.createdAt}</Moment>
          </span>
        ),
      },
    ];
    return columns.filter((column: any) => {
      if (column.title === "ACTIONS") {
        return deleteAccess.includes(user?.accessLevel);
      }
      return true;
    });
  };
  const columns = getColumns(user, access);

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  useEffect(() => {
    setPagination({ ...pagination, total: entries?.total });
  }, [entries]);

  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg uppercase">{title}</span>
        </div>
      }
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      open={isVisible}
      closable={false}
      extra={
        <Space>
          <Button type="default" onClick={() => setVisible(!isVisible)} danger>
            <X size={16} />
          </Button>
        </Space>
      }
    >
      <div className="">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4 bg-white">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search customer"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <Funnel size={16} />
              </Button>
            </Form>
          </div>
          <div className="flex ">
            <button
              color="#E50000"
              className="flex justify-center items-center border p-1 hover:bg-green-100"
            >
              <Download size={16} />
              <span
                className="ml-2"
                onClick={() =>
                  ExportToExcel(
                    entries?.records?.map((record: any, index: number) => {
                      return {
                        "S/N": index + 1,
                        Date: record?.createdAt
                          ? moment(record.createdAt).format("DD/MM/YYYY")
                          : "N/A",
                        Name: record?.name || "-",
                        Gender: record?.gender || "-",
                        Branch: record?.branch || "-",
                        Mobile: record?.mobile || "-",
                        Region: record?.region || "-",
                        District: record?.district || "-",
                        Ward: record?.ward || "-",
                        "Service Type": record?.serviceType || "-",
                        "Product Types": record?.serviceType || "-",
                        Registration: record?.registration || "-",
                        Make: record?.make || "-",
                        Model: record?.model || "-",
                        Mileage: record?.mileage || "-",
                        "Manf. Year": record?.year || "-",
                      };
                    }),
                    `${title}.xlsx`
                  )
                }
              >
                Export To Excel
              </span>
            </button>
          </div>
        </div>
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="shadow-sm">
            <Table
              size="small"
              dataSource={entries?.records}
              columns={columns}
              scroll={{ y: 700, x: "max-content" }}
              rowKey="id"
              bordered
              pagination={{
                current: pagination?.page,
                pageSize: pagination?.limit,
                total: pagination?.total,
              }}
              rowClassName={"hover:bg-gray-100 cursor-pointer"}
              onChange={(e: any) => handlePageChange(e)}
              loading={isLoading}
            />
          </div>
        )}
      </div>
    </Drawer>
  );
}
